<template>
    <!-- La imagen se limita al alto de la pantalla para que el dialogo nunca necesite scroll -->
    <v-dialog v-model="visible" width="460" transition="dialog-bottom-transition">
        <v-card class="rounded-0 pa-5">
            <v-col cols="12" class="d-flex justify-center pa-0 ma-0">
                <v-img :src="imagenCartel" contain width="100%" max-height="calc(100vh - 240px)" />
            </v-col>
            <v-card-actions class="d-flex justify-center align-center ma-1 pa-0 pt-5">
                <div class="ma-0 pa-0 d-flex flex-column justify-center align-center text-center">
                    <v-btn @click="irAContactos" elevation="0" width="200" color="primary" class="py-5">
                        CONTACTOS
                    </v-btn>
                    <v-btn @click="cerrarDialogoOpcionNivel" outlined elevation="0" width="200" color="secondary"
                        class="py-5 mt-1">
                        cerrar
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import cartel from '@/assets/opcionNiveles/cartel.png'

export default {
    name: 'DialogoOpcionNivel',
    data() {
        return {
            imagenCartel: cartel,
        }
    },
    computed: {
        ...mapGetters('opcionNivel', ['dialogoOpcionNivelVisible']),
        visible: {
            get() {
                return this.dialogoOpcionNivelVisible
            },
            set(valor) {
                if (!valor) this.cerrarDialogoOpcionNivel()
            },
        },
    },
    methods: {
        ...mapActions('opcionNivel', ['cerrarDialogoOpcionNivel']),
        irAContactos() {
            this.cerrarDialogoOpcionNivel()
            this.$nextTick(() => {
                this.$router.push('/mediosDeContacto').catch(() => { })
            })
        },
    },
}

</script>
